import { Container, Col, Row } from "reactstrap";
import * as SectionQL from "queries/section";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import SectionSchema from "@common/schema/section/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";
import { TagFilter, useTagFilter } from "components/tag-filter";

// Hoisted for the reason recorded in ../section/edit: a config literal is a new
// object every render and the provider rebuilds underneath it.
//
// Name, what it is for, and when it last changed. Deliberately not
// html/style/script: those are the unbounded fields, they are not on the
// listing fragment at all, and a listing is not where you read markup.
const LIST_FIELDS = {
  "/Public/Section": {
    fields: ["sectionId", "tags", "updatedAt"],
  },
};

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  // Tags are what a section is FOR — `page:header` and `page:footer` decide
  // where an element lands, and a per-locale section is an ordinary row with
  // an ordinary tag on it (P206). The column showing them has been here since
  // the port; what was missing was narrowing a site's list down to one of
  // them, which is a filter over rows this screen has already fetched. See
  // components/tag-filter.
  const tagFilter = useTagFilter();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <TagFilter state={tagFilter} />

      <List
        path={"viewer.account.sites.get.sections"}
        query={SectionQL.list}
        variables={params}
        schema={SectionSchema}
        widgets={widgets}
        target={{ $ref: "/Public/Section" }}
        empty={
          tagFilter.active
            ? `No sections tagged ${tagFilter.tag} among the ones loaded.`
            : "No sections yet."
        }
        onData={tagFilter.onData}
        filter={tagFilter.filter}
        config={LIST_FIELDS}
        content={({ item: { sectionId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${sectionId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
